/** 사이트 하단 회사 정보 */
export default function SiteFooter() {
  return (
    <footer>
      <div className="wrap">
        {/* 흰색 버전 로고 PNG 대신 기존 로고를 흰색으로 반전 */}
        <img src="/logo-acxionon-admin.svg" alt="AcXion-On" style={{ height: 16, filter: 'brightness(0) invert(1)' }} />
        <div>
          <div className="r">
            <span>상호 ㈜이테크시스템</span>
            <span>주소 (04528) 서울시 중구 소월로 3 에티버스 타워</span>
            <span>사업자등록번호 211-88-35257</span>
            <span>이메일 cloud.mkt@etechsystem.co.kr</span>
          </div>
          <div className="r">
            <a href="#">개인정보처리방침</a>
            <a href="#">이용약관</a>
            <span>© ETECH SYSTEM. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
